import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LearningPathForm from "../../components/forms/LearningPathForm";
import BasePage from "../common/BasePage";

export default function NewLearningPathPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const onSuccess = useCallback(
    (createdLearningPathId: number) => {
      navigate(`../${createdLearningPathId}`);
      toast({
        title: t("new_learning_path_page.learning_path_created"),
        description: t("new_learning_path_page.learning_path_created_message"),
        status: "success",
        isClosable: true,
      });
    },
    [navigate, t, toast],
  );

  const onError = useCallback(() => {
    toast({
      title: t("new_learning_path_page.learning_path_error"),
      description: t("new_learning_path_page.learning_path_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage title={t("new_learning_path_page.new_learning_path")}>
      <LearningPathForm onSuccess={onSuccess} onError={onError} />
    </BasePage>
  );
}
